import { useEffect, useState } from 'react';
import { iccManager } from '../lib/icc/iccManager';
import type { ICCProfileSnapshot } from '../lib/icc/types';

export function useIccProfiles() {
  const [snapshot, setSnapshot] = useState<ICCProfileSnapshot>(() => iccManager.getSnapshot());

  useEffect(() => {
    return iccManager.subscribe(setSnapshot);
  }, []);

  return snapshot;
}
